import { useMemo } from 'react';

import {
  DROP_ITEM_SIZE,
  InteractiveResponseProperties,
  RESPONSE_FREE,
} from '../settings/interactive-response.constants';
import {
  InteractiveResponseTitle,
  InteractiveResponseAnswerIcons,
} from '../../shared/interactive-response-shared';
import { getAnswers } from './interactive-response-sequence.utils';
import InteractiveDragDisplay from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-display';
import InteractiveSequenceDropDisplay from './interactive-sequence-drop-display';
import type { InteractiveResponseAnswerFragment } from '../../../../present/activity-answers.graphql.generated';
import * as Styled from './interactive-response-sequence.style';

const InteractiveResponseSequencePreviewAnswer = ({
  properties,
  attemptAnswers,
  showAnswer,
}: {
  properties: InteractiveResponseProperties;
  attemptAnswers: InteractiveResponseAnswerFragment;
  showAnswer: boolean;
}) => {
  const isFreeResponse =
    properties.interactiveResponse.answerType === RESPONSE_FREE;
  const answers = useMemo(() => {
    return getAnswers(
      attemptAnswers,
      properties.interactiveResponse.items,
      properties.interactiveResponse.variant
    );
  }, [
    properties.interactiveResponse.variant,
    properties.interactiveResponse.items,
    attemptAnswers,
  ]);

  return (
    <>
      <InteractiveResponseTitle
        title={properties.interactiveResponse.title}
        subTitle={properties.interactiveResponse.subTitle}
      />
      <Styled.InteractiveResponsePreviewDropItemContainer>
        {answers.map(answer => (
          <InteractiveSequenceDropDisplay
            key={answer.id}
            label={answer.label}
            labelLength={properties.interactiveResponse.labelLength}
            isCorrect={
              isFreeResponse || !showAnswer ? undefined : answer.isCorrect
            }
            labelBorder={properties.interactiveResponse.labelBorder}
          >
            {!isFreeResponse && showAnswer && (
              <InteractiveResponseAnswerIcons
                isCorrect={answer.isCorrect || false}
                animate={false}
              />
            )}
            <InteractiveDragDisplay
              scaleTo={DROP_ITEM_SIZE}
              imageUrl={answer.image}
              isFit={answer.isFit}
              description={answer.description}
              baseColour={answer.baseColour}
              variant={answer.variant}
              text={answer.text}
              richtext={answer.richtext}
            />
          </InteractiveSequenceDropDisplay>
        ))}
      </Styled.InteractiveResponsePreviewDropItemContainer>
    </>
  );
};

export default InteractiveResponseSequencePreviewAnswer;
